import { licenseService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    list ({ dispatch, commit }, data) {
        return licenseService
            .list(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    get ({ dispatch, commit }, id) {
        console.log('licenseStore: get');

        return licenseService
            .get(id)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    stop ({ dispatch, commit }, { id, data }) {
        console.log('licenseStore: update');
        commit('updateRequest');

        return licenseService
            .stop(id, data)
            .then(() => {
                commit('updateSuccess');
                dispatch('alert/success', { message: 'Licentie is stopggezet' }, { root: true });
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // add
    addRequest (state) {
        state.status = { adding: true };
    },
    addSuccess (state) {
        state.status = { added: true };
    },
    addFailure (state) {
        state.status = {};
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
